import { render, staticRenderFns } from "./ProductIntroductionTemplateList.vue?vue&type=template&id=252ea05d&scoped=true&"
import script from "./ProductIntroductionTemplateList.vue?vue&type=script&lang=js&"
export * from "./ProductIntroductionTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ea05d",
  null
  
)

export default component.exports